module.exports = __webpack_public_path__ + "assets/static/jpg/mc-prepaid.0e572c316a5e4f716200fa268bdc8681.jpg";


/*****************
 ** WEBPACK FOOTER
 ** ./app/pages/myCards/images/mc-prepaid.jpg
 ** module id = 502
 ** module chunks = 1
 **/